module.exports = __webpack_public_path__ + "img/products-1.1997e8c.jpg";